import React from "react";
import logo from "../../images/message.png";
import "./FAB.css";

import { useLocation, useNavigate } from "react-router-dom";

const FAB = () => {
    const location = useLocation();
    const navigate = useNavigate();

    if (location.pathname === "/" || location.pathname === "/login" || location.pathname === "/admin-login") {
        return null;
    }

    const handleClick = () => {
        navigate("/");
    };

    return(
        <div className="fab-container">
            <button className="fab-button" onClick={handleClick}>
                <b className="fab-text">Chat Now!</b>
                <img className="fab-icon" src={logo}/>
            </button>
        </div>
        
    );
};

export default FAB;